import React from 'react';
import { Empty } from 'antd';
import ConHomeUpsellStatsPage from '../../pages/ConHomeUpsellStatsPage';
import WindowNote from './WindowNote';

/**
 * Upselling stats for the campaign, rendered by the page that already computes them.
 *
 * The Campaign Summary is a hub: rather than a second query for the same
 * numbers, this scopes the existing page to the chosen campaign and window.
 * A fix there lands here, and the two cannot drift into disagreeing.
 *
 * Whether this tab is offered at all is the team's call, not this component's
 * -- see the HideUpsell gate on the page above.
 */
export default function UpsellsTab({ campaignId, from, to }) {
  if (!campaignId) {
    return <Empty description="Select a campaign" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      {/* The grid is a column per month, so the window is rounded out to whole
          months either end -- a range that starts mid-month still shows all of
          that month. */}
      <WindowNote from={from} to={to} />
      <ConHomeUpsellStatsPage embedded campaignId={campaignId} from={from} to={to} />
    </>
  );
}
